<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title class="subtitle-1">
        <v-row>
          <v-col sm="12" md="8">
            <template>
              {{ orderrItemGroup.product.title }}
            </template>
          </v-col>
          <v-col sm="12" md="4"
            >{{ orderrItemGroup.price / 100 }}
            {{ $t(mobConfig.currency) }}</v-col
          >
        </v-row>
      </v-list-item-title>
      <v-list-item-subtitle>
        {{ orderrItemGroup.length }} {{ $t(orderrItemGroup.priceListType) }}:
        {{ dateStartFormated }} - {{ dateEndFormated }}
      </v-list-item-subtitle>

      <v-list-item-subtitle>
        {{ $t(orderrItemGroup.orderrItems.items[0].skillLevelClient) }}
        |
        {{ $t(orderrItemGroup.orderrItems.items[0].language) }}
      </v-list-item-subtitle>

      <v-list-item-subtitle>
        {{ orderrItemGroup.description }}
      </v-list-item-subtitle>

      <ul>
        <li v-for="lesson in lessons" v-bind:key="lesson.timeFrom">
          <span>
            {{ formatLessonDateTime(lesson.timeFrom) }} -
            {{ formatLessonTime(lesson.timeTo) }}
          </span>
        </li>
      </ul>
    </v-list-item-content>
    <v-list-item-action v-if="!removeBtnDisabled">
      <v-btn icon @click="deleteItem" :disabled="currentOrderrExpired">
        <v-icon color="grey lighten-1">mdi-close</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import moment from "moment";

export default {
  name: "CartItemCourse",

  components: {},

  props: {
    orderrItemGroup: {
      type: Object,
      required: true
    },
    removeBtnDisabled: {
      type: Boolean,
      value: false
    }
  },

  computed: {
    mobConfig() {
      return this.$store.state.mobConfig;
    },

    dateStartFormated() {
      return moment(this.orderrItemGroup.dateStart).format("D. M. YYYY");
    },

    dateEndFormated() {
      return moment(this.orderrItemGroup.dateEnd).format("D. M. YYYY");
    },
    currentOrderrExpired() {
      return this.$store.state.currentOrderrExpired;
    },

    lessons() {
      return this.orderrItemGroup.orderrItems.items[0].lessons.sort(
        (first, second) => {
          if (first > second) {
            return -1;
          }
          if (first < second) {
            return 1;
          }
          return 0;
        }
      );
    }
  },

  methods: {
    deleteItem() {
      this.$store.dispatch("removeFromCart", this.orderrItemGroup);
    },

    formatLessonDateTime(awsDateTime) {
      return moment(awsDateTime).format("D. M. YYYY HH:mm");
    },

    formatLessonTime(awsDateTime) {
      return moment(awsDateTime).format("HH:mm");
    }
  }
};
</script>
